(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["page-faq-withsidebar-template"]) return;
  try {
    
$( document ).ready(function() {
  Reqs.lightbox();
  $('.image-container').magnificPopup({
    delegate: 'img', // child items selector, by clicking on it popup will open
    type: 'image',
    gallery:{ 
		enabled:true,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% icon-arrow-%dir%"></button>'
	},

     callbacks: {
          elementParse: function() { this.item.src = this.item.el.attr('src'); }
     }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-withsidebar-template"]) return;
  try {
    
$( document ).ready(function() {
  Reqs.lightbox();
  $('.image-container').magnificPopup({
    delegate: 'img', // child items selector, by clicking on it popup will open
    type: 'image',
    gallery:{ 
		enabled:true,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% icon-arrow-%dir%"></button>'
	},

     callbacks: { 
          elementParse: function(item) { item.src = item.el.attr('src'); } 
     }
  });

  $('.gallery-link').magnificPopup({
      type:'image',
       callbacks: { 
            elementParse: function(item) { item.src = item.el.attr('src'); } 
       }
  }); 
});


  } catch(e) { console.error(e); }
})();

})();
